import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

export const SELLER_INFO = gql`
  query sellerInfo {
    seller {
      id
      name
      status
      allowPiiSharing
      isOrdersExpeditionEnabled
      owner {
        name
      }
      document
      emails {
        address
        type
      }
      phones {
        number
        category
      }
      mainPhoneNumber
      address {
        street
        number
        city
        location {
          coordinates
        }
        provinceCode
        province
        countryCode
        complement
        neighborhood
        postcode
      }
      shop {
        workDays {
          weekDay
          enabled
          intervals {
            openingTime
            closingTime
          }
        }
        coverageArea {
          type
          coordinates
        }
        turboCoverageArea
      }
      category
    }
  }
`
export const SELLER_INFO_KEY = 'useSellerInfo'

export const useSellerInfo = options =>
  useQuery({
    queryKey: [SELLER_INFO_KEY],
    queryFn: () => client.request(SELLER_INFO),
    ...options,
  })
